
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    sources() {
      return this.item.sources
    },
  },
  methods: {
    makeDate(date){
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const [year, month] = date.split('-')
      return `· ${months[Number(month) - 1]} ${year}`
    }
  }
}
